/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import AdoptionTypeIcon from 'icons/SubstitutionsIcon';

const messages = defineMessages({
  title: {id: 'navigation.instructional-materials.substitutions'},
});

const SubstitutionsItem = () => (
  <RouteLinkItem
    iconBefore={AdoptionTypeIcon}
    route="midas/instructional-materials/substitutions"
    title={messages.title}
  />
);

export default SubstitutionsItem;
